<template>
  <div>
    <Search @searcher="onSearch" :placeholder="searchPlaceholder">
    </Search>
    <div slot="content">
      <div v-if="search" class="search-box">
        <div class="search-results-header">
          <h3>Search Results</h3>
        </div>
        <slot v-if="!currentGroupCode">
          <div class="search-box-groups">
            <h3>Groups</h3>
            <div class="search-box-content">
              <div v-if="appWideSearchGroupList.length <= 0">
                <p class="no-results-found">No results found for groups.</p>
              </div>
              <router-link v-for="(group, groupIndex) in appWideSearchGroupList" v-bind:key="groupIndex" :to="'/group/' + group.code">
                <div class="group">
                  <div class="group-color" :style="{background: utils.stringToBgRGBAColor(group.code)}"></div> <span>{{group.name}}</span>
                </div>
              </router-link>
            </div>
          </div>
        </slot>
        <div class="search-box-books">
          <h3>Books</h3>
          <div class="search-box-content">
            <div v-if="appWideSearchBookList.length <= 0">
              <p class="no-results-found">No results found for books.</p>
            </div>
            <slot v-for="(book, bookIndex) in appWideSearchBookList">
              <router-link :to="getBookLink(book)">
                <div v-bind:key="bookIndex" class="book list-item">
                  <span class="search-box-image">
                    <img class="book-img" :src="$config.get('ecApi') + 'web/books/' + book.id + '/cover?width=200'">
                  </span>
                  <span :title="book.title" class="book-title">{{utils.truncateString(book.title, 70)}}</span>
                  <slot v-if="book.groupName && !currentGroupCode">
                    <div class="bubble">
                      <div class="group-bubble" :style="{background: utils.stringToBgRGBAColor(book.groupCode, 30)}">
                        <span :title="book.groupName">{{utils.truncateString(book.groupName, 18)}}</span>
                      </div>
                    </div>
                  </slot>
                  <slot v-else>
                    <div class="bubble">
                    </div>
                  </slot>
                </div>
              </router-link>
            </slot>
          </div>
        </div>
        <div class="search-box-resources">
          <h3>Resources</h3>
          <div class="search-box-resources-content">
            <div v-if="appWideSearchResourceList.length <= 0">
              <p class="no-results-found">No results found for resources.</p>
            </div>
            <slot v-for="(resource, resourceIndex) in appWideSearchResourceList">
              <div v-bind:key="resourceIndex" :class="{'overlay':resource.locked}" class="book-resource list-item" @click="_ => {if (!resource.locked) openResource(resource, resource.attachments)}" >
                <span class="image-left-cell">
                  <img class="book-type" :src="($config.get('basePathFiles') + (utils.resourceTypeImg(resource.category, resource.url)))" />
                </span>   
                <span class="resource-title" v-if="resource.title">{{utils.truncateString(resource.title, 62)}}</span>
                <span class="resource-title" v-else>{{utils.truncateString(resource.filename, 62)}}</span>
                
                <slot v-if="resource.bookGroupName && resource.resourceGroup && !currentGroupCode">
                  <div class="bubble">
                    <div class="group-bubble" :style="{background: utils.stringToBgRGBAColor(resource.groupCode, 30)}">
                      <span :title="resource.bookGroupName">{{utils.truncateString(resource.bookGroupName, 17)}}</span>
                    </div>
                  </div>
                </slot>
                <slot v-else-if="resource.bookGroupName && !currentGroupCode">
                  <div class="bubble">
                    <div class="group-bubble">
                      <span :title="resource.bookGroupName">{{utils.truncateString(resource.bookGroupName, 17)}}</span>
                    </div>
                  </div>
                </slot>
                <slot v-else>
                  <div class="bubble">
                  </div>
                </slot>
              </div>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import utils from '@/utils/utils.js';
import storeHelpers from '@/utils/storeHelpers.js';
import Search from '@/components/widgets/Search';
import vClickOutside from 'v-click-outside';
import analytics from '@/utils/analytics.js';

export default {
  name: 'AppWideSearch',
  props: ['currentGroupCode', 'searchPlaceholder'],
  components: {
    Search
  },
  data: function() {
    return {
      utils: utils,
      search: '',
      bookList: [],
      groupList: [],
      resourceList: [],
      attachmentList: [],
      attachmentsByResourceId: {},
      unwatchFunctions: [],
      searchBoxActive: false
    }
  },
  destroyed: function() {
    _.each(this.unwatchFunctions, function(unwatchFunction) {
      unwatchFunction();
    });
  },
  mounted() {
   
  },
  computed: {
    appWideSearchBookList () {
      return this.bookList.filter(book => {
        return book.title.toLowerCase().includes(this.search.toLowerCase())
      })
    },
    appWideSearchGroupList () {
      return this.groupList.filter(group => {
        return group.name.toLowerCase().includes(this.search.toLowerCase())
      })
    },
    appWideSearchResourceList () {
      //index: 102
      // index: 296
      // index: 356
      return this.resourceList.filter((resource)=> {
          return resource.title.toLowerCase().includes(this.search.toLowerCase()) && resource.visible;
      })
    }
  },
  methods: {
    dataUpdated: function () {
      var t = this
      var groupList = _.orderBy(t.$store.state.groups, [ function(group) { return group.name.trim().toLowerCase();} ], ['asc']);
      
      var bookList = _.orderBy(t.$store.state.bookList, [ function(book) { return book.title.trim().toLowerCase();} ], ['asc']);;
      var attachments = t.$store.state.attachments;
      var resources = t.$store.state.resources;

      // filter out items if only for one specific group
      if (t.currentGroupCode && t.currentGroupCode.length > 0) {
        
        //fiter all books according to group
        bookList = _.filter(bookList, function (book) {
          return book.groups && book.groups.indexOf(t.currentGroupCode) >= 0
        });

        // filter out attachments not part of this group
        attachments = _.filter(attachments, function(attachment) {
          return attachment.groups && attachment.groups.indexOf(t.currentGroupCode) >= 0
        });

        t.groupList = _.filter(groupList, function(group) {
          return group.code === t.currentGroupCode;
        });
      } else {
        t.groupList = groupList;
      }

      t.attachmentList = attachments;
      t.attachmentsByResourceId = _.groupBy(t.attachmentList, "resource");

      //filter out resources not used (no attachments)
      resources = _.filter(t.$store.state.resources, function (resource) {
        return t.attachmentsByResourceId[resource._id] && t.attachmentsByResourceId[resource._id].length > 0;
      });

      //set groupName, if more than one group found set as 1st group
      var groupByCode = _.keyBy(t.groupList, "code");
      _.each(bookList, function (book) {
        if (book.groups) {
          var groupFound = _.find(book.groups, function(group) {
            return groupByCode[group];
          });

          if(groupFound) {
            book.groupName = groupByCode[groupFound].name;
            book.groupCode = groupByCode[groupFound].code;
          }
        }
      });

      //set bookGroupName, if more than one group found set as 1st group, if no group found display book name
      var booksByBookId = _.keyBy(bookList, "id");
      _.each(resources, function(resource) {
        let attachmentForResource = t.attachmentsByResourceId[resource._id];

        // if the user is not in a specific group, look for the first group in any attachment
        if(!t.currentGroupCode || t.currentGroupCode.length === 0) {
          _.each(attachmentForResource, function(attachment) {
            if (attachment && attachment.groups && attachment.groups.length > 0) {
              var groupFound = _.find(attachment.groups, function(group) {
                return groupByCode[group];
              });

              if(groupFound) {
                resource.bookGroupName = groupByCode[groupFound].name;
                resource.resourceGroup = true;
                resource.groupCode = groupByCode[groupFound].code;

                return false;
              }
            }
          });
        }

        // if a group hasn't been set, look for a book name
        if (!resource.bookGroupName) {
          _.each(attachmentForResource, function(attachment) {
            if(booksByBookId[attachment.book]) {
              resource.bookGroupName = booksByBookId[attachment.book].title;
              resource.resourceGroup = false;
              return false;
            }
          })
        }
      })

      // filter out inappropriate books and resources
      t.bookList = _.filter(bookList, function(book) {
        return book.groupName || t.currentGroupCode 
      });

      // filter out notes, drawings and sketches or no bookGroupName
      resources = _.filter(resources, function(resource) {
        if(resource.bookGroupName || t.currentGroupCode) {
          if (resource.category)
            return !utils.isAnnotation(resource);
        } 
        return false;
      });
      
      // expand resource list with attachment instances
      var resourcesButIncludingAttachmentInstances = [];
      _.each(resources, function(resource) {
        if(resource.category === "assessment") {
          var instanceAdded = false;
          var attachmentsForResource = t.attachmentsByResourceId[resource._id];
          _.each(attachmentsForResource, function(attachment) {
            if(storeHelpers.isSpecificAssessment(attachment)) {
              instanceAdded = true;  
              var resourceClone = Object.assign({}, resource);
              resourceClone.title = resourceClone.title + ' (' + attachment.settings.title + ')';
              resourcesButIncludingAttachmentInstances.push(resourceClone);
            }
          });

          if(!instanceAdded) {
            resourcesButIncludingAttachmentInstances.push(Object.assign({}, resource));
          }
        } else {
          resourcesButIncludingAttachmentInstances.push(resource);
        }
      });

      // Add hidden property to resources
      // Add locked property to resource
      _.each(resourcesButIncludingAttachmentInstances, resource => {
        var attachmentsForResource = t.attachmentsByResourceId[resource._id];
        var checkForLockedAttachments = utils.filterLockedResources(t, attachmentsForResource);
        if (attachmentsForResource && attachmentsForResource[0].visible) {
          resource.visible = attachmentsForResource[0].visible;
        }

        _.each(checkForLockedAttachments, checkForLockedAttachment => {
          if (checkForLockedAttachment && checkForLockedAttachment.locked) {
            resource.locked = checkForLockedAttachment.locked;
          }
        })
        
        resource.attachments = attachmentsForResource;
      });

      t.resourceList = resourcesButIncludingAttachmentInstances;

    },
    onSearch: function(val) {
      if (this.unwatchFunctions.length == 0) {
        this.unwatchFunctions = utils.watchStorePropertiesWithCallback(this, ['bookList', 'resources', 'attachments', 'groups'], this.dataUpdated);
      }
      this.search = val;
      this.$emit('appWideSearchActive', val)
    },
    openResource: function(resource, attachments) {
      var from = this.currentGroupCode ? 4 : 3;
      var optionObj = {
        "from" : from
      }
      var attachmentIDs = _.map(attachments, '_id')
      utils.openResource(this, resource, attachmentIDs, optionObj);
    },
    getBookLink: function (book) {
      var lastAccessedPage = storeHelpers.getBookById(this, book.id).lastAccessedPage;
      return utils.getBookLink(book, lastAccessedPage ? lastAccessedPage : null) + "?search=true";
    }
  }
}
</script>

<style scoped lang="scss">
@import "src/css/vars.scss";

.search-results-header {
  padding: 12px 12px;
  text-align: center;
  border-bottom: 1px solid $border-color;
  background: $background-color;
}

.search-box {
  text-align: left;
}

.search-box-content {
  background: $lightest-bg-color;
}

.no-results-found {
  padding-left: 20px;
  background: $background-color;
  font-style: italic;
}

.search-box-groups h3, .search-box-books h3, .search-box-resources h3 {
  padding: 7px 10px;
}

.search-box-groups, .search-box-books, .search-box-resources {
  padding: 7px 0px;
}

.group {
  text-align: left;
  border-bottom: 1px solid $background-color-dark;
  height: 40px;
  background: $white;
}

.group-color {
  width:10px;
  height:100%;
  background: black;
  display: inline-block;
}

.group:hover {
  background: $background-color-dark;
  cursor: pointer;
}

.group span {
  margin-left: 10px;
  display: inline-block;
  vertical-align: top;
  margin-top: 7px;
}

.book {
  background: $white;
  padding: 10px 0px 10px 10px;
  display: table;
  width: 100%;
}

.book:hover {
  background: $background-color-dark;
  cursor: pointer;
}

.search-box-image {
  display: table-cell;
  width: 50px;
  padding-right: 10px;
}

.book-img {
  background:#c5c5c5;
  min-width: 50px;
}

.book-title {
  display: table-cell;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-left: 10px;
  width: 500px;
}



.bubble {
  display: table-cell;
  width: 20%;
}

.group-bubble {
  background: rgba(0, 102, 204, 0.3);
  padding: 5px;
  width: 150px;
  text-overflow: ellipsis;
  margin-left: 10px;
  border-radius: 5px;
  white-space: nowrap;
  text-align: center;
}

.group-bubble span {
  font-weight: 400;
  color: $dark-font-color-lighter;
  font-size: 10pt;
}

.book-resource {
  display: table;
  height: 85px;
  background: $white;
  padding: 10px 0px 10px 10px;
  width: 100%;

  .image-left-cell {
    display: table-cell;
    width: 40px;

    .book-type {
      position: relative;
      min-width: 32px;
      float: left;
      margin-top: calc(50% - 25px);
      margin-right: 10px;
      margin-left: 7px;
    }
  }

  .resource-title {
    display: table-cell;
    overflow: hidden;
    text-overflow: ellipsis;
    padding-left: 10px;
    width: 800px;
  }
}

.book-resource:hover {
  background: $background-color-dark;
  cursor: pointer;
}

</style>
